export type Player = "X" | "O";
export type CellValue = Player | null;
export type Board = CellValue[];

export interface Scores {
  X: number;
  O: number;
  draws: number;
}

export interface WinResult {
  winner: Player;
  line: number[];
}

export const WINNING_LINES: number[][] = [
  [0, 1, 2], // top row
  [3, 4, 5], // middle row
  [6, 7, 8], // bottom row
  [0, 3, 6], // left col
  [1, 4, 7], // middle col
  [2, 5, 8], // right col
  [0, 4, 8], // diagonal
  [2, 4, 6], // anti-diagonal
];

export const INITIAL_BOARD: Board = Array(9).fill(null);

export const INITIAL_SCORES: Scores = { X: 0, O: 0, draws: 0 };

const STORAGE_KEY = "tictactoe-scores";

export function loadScores(): Scores {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (
        typeof parsed.X === "number" &&
        typeof parsed.O === "number" &&
        typeof parsed.draws === "number"
      ) {
        return parsed;
      }
    }
  } catch {
    // ignore
  }
  return { ...INITIAL_SCORES };
}

export function saveScores(scores: Scores): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scores));
  } catch {
    // ignore
  }
}

export function clearScores(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function checkWinner(board: Board): WinResult | null {
  for (const line of WINNING_LINES) {
    const [a, b, c] = line;
    if (board[a] && board[a] === board[b] && board[a] === board[c]) {
      return { winner: board[a] as Player, line };
    }
  }
  return null;
}

export function checkDraw(board: Board): boolean {
  return board.every((cell) => cell !== null);
}
